export const FOUNDING_OWNER_ID = '1060755378515738664';
